import styled from "styled-components";
import { ids } from "@icarros/theme-react";
const { size } = ids || {};
export const LikertButton = styled.button `
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.3s;
  margin: ${size.general.ids_size_general_8x};
  gap: ${size.general.ids_size_general_8x};
`;
export const StyledLikert = styled.div `
  display: flex;
  justify-content: space-around;
`;
//# sourceMappingURL=Likert.style.js.map